export const buildCssClassName = (
  CSSClassNameStrings: string[] | boolean[] | any[]
): string =>
  CSSClassNameStrings.filter(
    (s: string | boolean) => typeof s === 'string'
  ).join(' ');

export const addInvalidClassIfComponentIsInvalid = (
  isInvalid: boolean
): string | boolean => isInvalid && 'p-invalid';
